/**
 * Depois de cada Publish os arquivos do app ganham nomes novos. Quem já estava com a página aberta (ou guardada no
 * navegador do celular/WhatsApp) tenta baixar um arquivo antigo que não existe mais e a tela mostrava
 * "Algo não saiu como esperado" (cliente não conseguia abrir a proposta). A saída é recarregar a página uma vez,
 * pegando a versão nova do app.
 */
const STALE_ASSET_PATTERN =
  /dynamically imported module|Importing a module script failed|error loading dynamically imported module|ChunkLoadError|Loading chunk [\w-]+ failed|Failed to fetch dynamically imported/i;

const RELOAD_FLAG = 'ameup_stale_reload_at';
/** Só recarrega sozinho uma vez a cada 60 s: se o erro persistir, a tela de erro aparece (sem laço de recarga). */
const RELOAD_COOLDOWN_MS = 60_000;

export const isStaleAssetError = (error: unknown): boolean => {
  const message = typeof error === 'string' ? error : (error as { message?: unknown } | null)?.message;
  return typeof message === 'string' && STALE_ASSET_PATTERN.test(message);
};

/** Recarrega a página para pegar a versão nova do app. Devolve true se disparou o recarregamento. */
export const reloadForNewVersion = (now: number = Date.now()): boolean => {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_FLAG) || 0);
    if (last && now - last < RELOAD_COOLDOWN_MS) return false;
    sessionStorage.setItem(RELOAD_FLAG, String(now));
  } catch {
    // Sem sessionStorage: ainda assim tenta uma vez, mas sem controle de laço (navegador privativo raro).
  }
  window.location.reload();
  return true;
};

/** Escuta o erro de arquivo antigo do Vite e do navegador antes de qualquer tela. */
export const installStaleAppReload = (): void => {
  window.addEventListener('vite:preloadError', (event) => {
    if (reloadForNewVersion()) event.preventDefault();
  });
  window.addEventListener('unhandledrejection', (event) => {
    if (isStaleAssetError(event.reason)) reloadForNewVersion();
  });
};
